export const COUPON_VERIFYING = 'COUPON_VERIFYING'
export const COUPON_VERIFIED = 'COUPON_VERIFIED'
export const COUPON_VERIFICATION_FAILED = 'COUPON_VERIFICATION_FAILED'

export const COUPON_GENERATING = 'COUPON_GENERATING'
export const COUPON_GENERATED = 'COUPON_GENERATED'
export const COUPON_GENERATION_FAILED = 'COUPON_GENERATION_FAILED'
export const COUPON_GENERATION_RESET = 'COUPON_GENERATION_RESET'

export const COUPON_LISTING = 'COUPON_LISTING'
export const COUPON_LISTED = 'COUPON_LISTED'
export const COUPON_LISTING_FAILED = 'COUPON_LISTING_FAILED'

export const COUPON_DELETING = 'COUPON_DELETING'
export const COUPON_DELETED = 'COUPON_DELETED'
export const COUPON_DELETION_FAILED = 'COUPON_DELETION_FAILED'

export const COUPON_ACTIVE_INACTIVE_REQUEST = 'COUPON_ACTIVE_INACTIVE_REQUEST'
export const COUPON_ACTIVE_INACTIVE_SUCCESS = 'COUPON_ACTIVE_INACTIVE_SUCCESS'
export const COUPON_ACTIVE_INACTIVE_FAILED = 'COUPON_ACTIVE_INACTIVE_FAILED'

